const widgets = document.querySelectorAll(".js-stars-rating-input");
[...widgets].forEach(widget => {
	widget.addEventListener("change", onChangeHandler, false);
});

function onChangeHandler({ target }) {
	const controls = this.querySelectorAll("input[type='checkbox']");
	const reset = +target.value === +this.dataset.value;

	[...controls].forEach((input, index) => {
		if (reset) {
			input.checked = false;
		} else {
			input.checked = target.value > index;
		}
	});

	target.blur();
	this.dataset.value = reset ? 0 : target.value;
}
